import gql from 'graphql-tag';

const UPDATE_NETWORK = gql`
  mutation Mutation($deviceSerialNo: String!, $networkProvider: String!) {
    updateNetworkProvider(deviceSerialNo: $deviceSerialNo, networkProvider: $networkProvider) {
      code
    }
  }
`;

export default UPDATE_NETWORK;
